const GET_AZURE_MONITOR_APPLICATIONS = "GET_AZURE_MONITOR_APPLICATIONS";
const GET_AZURE_MONITOR_APPLICATIONS_SUCCESS =
  "GET_AZURE_MONITOR_APPLICATIONS_SUCCESS";
const GET_AZURE_MONITOR_APPLICATIONS_ERROR =
  "GET_AZURE_MONITOR_APPLICATIONS_ERROR";

const GET_AZURE_MONITOR_APPLICATIONS_PARAMS =
  "GET_AZURE_MONITOR_APPLICATIONS_PARAMS";
const GET_AZURE_MONITOR_APPLICATIONS_PARAMS_SUCCESS =
  "GET_AZURE_MONITOR_APPLICATIONS_PARAMS_SUCCESS";
const GET_AZURE_MONITOR_APPLICATIONS_PARAMS_ERROR =
  "GET_AZURE_MONITOR_APPLICATIONS_PARAMS_ERROR";

export {
  GET_AZURE_MONITOR_APPLICATIONS,
  GET_AZURE_MONITOR_APPLICATIONS_SUCCESS,
  GET_AZURE_MONITOR_APPLICATIONS_ERROR,
  GET_AZURE_MONITOR_APPLICATIONS_PARAMS,
  GET_AZURE_MONITOR_APPLICATIONS_PARAMS_SUCCESS,
  GET_AZURE_MONITOR_APPLICATIONS_PARAMS_ERROR,
};
